import React from 'react';
import { bool, func, string } from 'prop-types';

import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
} from '@chakra-ui/react';

import {
  ENABLE_BANK_TRANSFER,
  ENABLE_SEND_GIFT,
  ENABLE_GIFT_CONFIRMATION,
} from '@/constants/feature-flags';
import { TEXT_PROPS } from '@/constants/default-props';
import { ASSETS_BG_TEXTURE } from '@/constants/assets';

import Confirmation from '../Confirmation/Lazy';
import { styleGift } from './styles';

import ModalBank from './ModalBank';
import ModalAddress from './ModalAddress';

function ModalGiftCard({ onClose, visible, onCopyText, lang }) {
  return (
    <Drawer size="full" onClose={onClose} isOpen={visible}>
      <DrawerOverlay />
      <DrawerContent maxWidth="500px">
        <DrawerCloseButton marginTop="12px" />
        <DrawerBody
          {...TEXT_PROPS.body}
          padding={'2rem'}
          overflowX="hidden"
          bgImage={ASSETS_BG_TEXTURE}
          css={styleGift}
        >
          {ENABLE_BANK_TRANSFER && <ModalBank lang={lang} onCopyText={onCopyText} />}
          {ENABLE_SEND_GIFT && <ModalAddress lang={lang} onCopyText={onCopyText} />}
          {ENABLE_GIFT_CONFIRMATION && <Confirmation lang={lang} />}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

ModalGiftCard.propTypes = {
  lang: string,
  visible: bool.isRequired,
  onClose: func.isRequired,
  onCopyText: func.isRequired,
};

ModalGiftCard.defaultProps = {
  lang: 'id',
};

export default ModalGiftCard;
